// extracted by mini-css-extract-plugin
export var mainContainer = "reservation-detail-module--mainContainer--3PkeQ";
export var backToTopButton = "reservation-detail-module--backToTopButton--1NwRK";